angular.module('access.Nodes')
    .controller('SignFileSigneesModalController', [
        '$modalInstance',
        '$q',
        '$scope',
        '$translate',
        'Esignature',
        'flashMessagesService',
        'NotaryAnnotation',
        'Session',
        function (
            $modalInstance,
            $q,
            $scope,
            $translate,
            Esignature,
            flashMessagesService,
            NotaryAnnotation,
            Session
        ) {
            const isSupportEmbeddedSignature = $scope.settings.node_supports_notary_embedded_signatures;

            $scope.signees = {
                emails: [{ email: Session.account.email, name: Session.account.name }]
            };

            $scope.modal = $modalInstance.options;
            $scope.modal.title = $translate.instant('esignature_sign_dialog_signees_title');
            $scope.modal.actionButton = $translate.instant('esignature_sign_dialog_signees_submit');
            $scope.cancel = $scope.close = () => $modalInstance.dismiss();
            $scope.disableSubmit = () => $scope.signees.emails.length <= 0 || $scope.modal.loading;
            $scope.onRecipientsUpdate = (recipients) => $scope.signees.emails = recipients.map(email => ({email: email}));

            $scope.ok = () => {
                $scope.modal.loading = true;

                return $q.resolve()
                    .then(() => {
                        if (!($scope.pdf instanceof ArrayBuffer)) {
                            return null;
                        }

                        return NotaryAnnotation.submit(
                            $scope.settings.notary_annotations_path,
                            $scope.pdf,
                            $scope.signees.emails
                        );
                    })
                    .then((annotations) => {
                        const esignatureData = {
                            node_uuid: $scope.node.uuid,
                            node_revision: $scope.node.revision,
                            emails: $scope.signees.emails.map(({ email }) => email),
                            ...(annotations ? { annotations: annotations } : {})
                        };

                        return Esignature.save(esignatureData).$promise
                    })
                    .then((esignature) => $modalInstance.close(esignature))
                    .catch((error) => {
                        if (error.message) {
                            // This catch will handle only NotaryAnnotation errors or some exception.
                            // Failed BE request will be handled automatically by default error handlers
                            flashMessagesService.add($translate.instant(error.message), flashMessagesService.ERROR);
                        }
                    })
                    .finally(() => $scope.modal.loading = false);
            };

            $modalInstance.opened.then(() => {
                if (!isSupportEmbeddedSignature || $scope.pdfError) {
                    flashMessagesService.add(
                        $translate.instant($scope.pdfError || 'esignature_sign_dialog_embedded_signature_not_supported'),
                        flashMessagesService.INFO
                    );
                }
            });
        }
    ]
    );
